import React, { useState, Fragment } from 'react';
import Swiper from 'react-id-swiper';
import styled, { css } from 'styled-components';
import { breakpoints, palette } from '../../constants/styles';
import ProblemCard from './ProblemCard';
import SolutionCard from './SolutionCard';
import Icon from '../shared/Icon';

const AvatarMaria = 'https://s3.us-east-2.amazonaws.com/finauta/avatars/Maria.png';
const AvatarEmmanuel = 'https://s3.us-east-2.amazonaws.com/finauta/avatars/Emmanuel.png';
const AvatarFamilia = 'https://s3.us-east-2.amazonaws.com/finauta/avatars/Familia.png';

const Conversation = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  margin-bottom: 30px;

  &:last-child {
    margin-bottom: 0px;
  }

  ${breakpoints.desktop} {
    flex-direction: row;
    justify-content: space-evenly;
  }
`;


const StyledUnderline = styled.u`
  text-decoration: none;
  border-bottom: 1.5px solid ${palette.finautaOldOrange};
`;

const StyledNavigation = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  top: -16px;
  z-index: 10000000;

  @media screen and (min-width: 1140px) {
    top: -146px;
    width: 100vw;
    justify-content: space-between;
  }
`;

const StyledLeftButton = css`
  margin: 0 3em 0 0;
  cursor: pointer;
  @media screen and (min-width: 1140px) {
    margin-left: 20px;
  }
`;
const StyledRightButton = css`
  margin: 0 0 0 3em;
  cursor: pointer;
  @media screen and (min-width: 1140px) {
    margin-right: 20px;
  }
`;

const MySwiper = () => {
  const [swiper, updateSwiper] = useState(null);
  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };
  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };
  return (
    <Fragment>
      <Swiper
        getSwiper={updateSwiper}
        {...{
          breakpointsInverse: true,
          // slideClass: 'custom-swiper-slide',
          wrapperClass: 'custom-wrapper-class',
          // Responsive breakpoints
          breakpoints: {
            1: {
              slidesPerView: 1,
              spaceBetween: 50,
              width: 280,
            },
            370: {
              slidesPerView: 1,
              spaceBetween: 50,
              width: 330,
            },
            420: {
              slidesPerView: 1,
              spaceBetween: 80,
              width: 390,
            },
            500: {
              slidesPerView: 1,
              spaceBetween: 80,
              width: 460,
            },
            580: {
              slidesPerView: 1,
              spaceBetween: 80,
              width: 540,
            },
            660: {
              slidesPerView: 1,
              spaceBetween: 80,
              width: 620,
            },
            740: {
              slidesPerView: 1,
              spaceBetween: 80,
              width: 700,
            },
            820: {
              slidesPerView: 1,
              spaceBetween: 80,
              width: 780,
            },
            900: {
              slidesPerView: 1,
              spaceBetween: 80,
              width: 860,
            },
            980: {
              slidesPerView: 1,
              spaceBetween: 80,
              width: 940,
            },
            1024: {
              slidesPerView: 1,
              spaceBetween: 0,
              width: 1024,
            },
            1100: {
              slidesPerView: 1,
              spaceBetween: 0,
              width: 1100,
            },
            1200: {
              slidesPerView: 1,
              spaceBetween: 0,
              width: 1200,
            },
            1300: {
              slidesPerView: 1,
              spaceBetween: 0,
              width: 1300,
            },
            1500: {
              slidesPerView: 1,
              spaceBetween: 0,
              width: 1500,
            },
          },
          pagination: {
            el: '.pagination',
            type: 'bullets',
            clickable: true,
          },
        }}
      >
        <Conversation>
          <ProblemCard
            avatar={AvatarMaria}
            name="María"
            bullets={[
              <Fragment>Ahorra lo que le sobra al final de cada mes en el banco</Fragment>,
              <Fragment>
                Tiene
                <StyledUnderline> muchas metas, pero no un plan </StyledUnderline>
                para lograrlas
              </Fragment>,
            ]}
          />
          <SolutionCard title="¿Cómo le ayudó Finauta?" ctaText="→ Ver su plan" ctaFunction={() => { window.location = '/plan/res/7314/preview'; }}>
            <Fragment>Tras obtener su plan de ahorro gratis, se contactó con un experto que le recomendó el mejor lugar para invertir su dinero</Fragment>
          </SolutionCard>
        </Conversation>
        <Conversation>
          <ProblemCard
            avatar={AvatarEmmanuel}
            name="Emmanuel"
            bullets={[
              <Fragment>
                Le preocupa
                <StyledUnderline> no saber con cuánto se retirará</StyledUnderline>
              </Fragment>,
              <Fragment>Quiere saber dónde le conviene ahorrar para su retiro</Fragment>,
            ]}
          />
          <SolutionCard title="¿Cómo le ayudó Finauta?" ctaText="→ Ver su resultado" ctaFunction={() => { window.location = '/retiro/res/f4a7b5'; }}>
            <Fragment>Con nuestra herramienta, Emmanuel descubrió cuánto ahorrar al mes para lograr su retiro ideal</Fragment>
          </SolutionCard>
        </Conversation>
        <Conversation>
          <ProblemCard
            avatar={AvatarFamilia}
            name="Ana y Juan"
            bullets={[
              <Fragment>Quieren poder pagar la educación de su hijo y comprar su propia casa</Fragment>,
              <Fragment>
                Cada año su hijo tiene más gastos, y
                <StyledUnderline> no saben si lograrán sus metas</StyledUnderline>
              </Fragment>,
            ]}
          />
          <SolutionCard title="¿Cómo le ayudó Finauta?" marginBottom="0">
            <Fragment>Uno de nuestros expertos les ayudó a definir un plan a la medida para asegurar su futuro sin perjudicar su presente</Fragment>
          </SolutionCard>
        </Conversation>
      </Swiper>
      <StyledNavigation>
        <Icon icon="leftIcon" color={palette.primaryColor} size={window.innerWidth > 1140 ? 50 : 25} styles={StyledLeftButton} onClick={goPrev} />
        <Icon icon="rightIcon" color={palette.primaryColor} size={window.innerWidth > 1125 ? 50 : 25} styles={StyledRightButton} onClick={goNext} />
      </StyledNavigation>
    </Fragment>
  );
};
export default MySwiper;
